import { motion } from "framer-motion";
import { MoreVertical, Lock, Download, Plus, History, Settings, Home } from "lucide-react";
import { FakePage, Hot, HomeScreen, HOST } from "./parts";

const ChromeBar = ({ hot }) => (
  <div className="absolute inset-x-0 top-6 z-10 bg-white border-b border-slate-200 px-2 py-1.5 flex items-center gap-1.5">
    <Home className="w-3.5 h-3.5 text-slate-500" />
    <div className="flex-1 h-6 rounded-full bg-slate-100 flex items-center gap-1 px-2 text-[9px] text-slate-600 overflow-hidden whitespace-nowrap"><Lock className="w-2.5 h-2.5 shrink-0" /><span className="truncate">{HOST}</span></div>
    {hot ? <Hot className="p-0.5"><MoreVertical className="w-4 h-4 text-slate-700" /></Hot> : <MoreVertical className="w-4 h-4 text-slate-700" />}
  </div>
);

const Page = ({ dim }) => <div className="absolute inset-0 top-9"><FakePage dim={dim} /></div>;

export const AndroidMenu = () => (<><Page /><ChromeBar hot /></>);

const Item = ({ icon: Icon, label, hot }) => {
  const body = <span className="flex w-full items-center gap-2 px-2.5 py-1.5 text-[10px]"><Icon className="w-3.5 h-3.5 text-slate-600" />{label}</span>;
  return hot ? <Hot className="w-full rounded-md bg-orange-50">{body}</Hot> : body;
};

export const AndroidList = () => (
  <>
    <Page dim /><ChromeBar />
    <motion.div className="absolute right-2 top-12 z-20 w-36 rounded-xl bg-white shadow-2xl border border-slate-100 py-1.5 origin-top-right"
      initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 260, damping: 22, delay: 0.15 }}>
      <Item icon={Plus} label="Nuova scheda" />
      <Item icon={History} label="Cronologia" />
      <Item icon={Download} label="Installa app" hot />
      <Item icon={Settings} label="Impostazioni" />
    </motion.div>
  </>
);

export const AndroidDialog = () => (
  <>
    <Page dim /><ChromeBar />
    <div className="absolute inset-0 z-10 bg-slate-900/40" />
    <motion.div className="absolute inset-x-4 top-1/3 z-20 rounded-2xl bg-white p-4 space-y-3 shadow-2xl"
      initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.15 }}>
      <div className="text-[11px] font-bold">Installare l'app?</div>
      <div className="flex items-center gap-2"><img src="/icon-192.png" alt="" className="w-8 h-8 rounded-lg" /><div className="text-[10px] font-medium">K Gestionale<div className="text-slate-400 font-normal truncate max-w-[110px]">{HOST}</div></div></div>
      <div className="flex justify-end gap-3 text-[10px] font-semibold text-sky-700">
        <span className="py-1">Annulla</span>
        <Hot className="px-2 py-1">Installa</Hot>
      </div>
    </motion.div>
  </>
);

export const AndroidHome = () => <HomeScreen />;
